"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBannerContext = exports.BannerContextProvider = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = require("react");
const defaultContext = {
  type: "info"
};
const BannerContext = (0, _lodestarUtils.createContext)(defaultContext, "BannerContext");
const BannerContextProvider = BannerContext.Provider;
exports.BannerContextProvider = BannerContextProvider;
const useBannerContext = () => (0, _react.useContext)(BannerContext);
exports.useBannerContext = useBannerContext;
//# sourceMappingURL=BannerContext.js.map